import React, { useState, useEffect } from "react";
import { Form, Input, Select, InputNumber } from "antd";
import { ReactComponent as DownIcon } from "../../../assets/svgs/dropdown_icon.svg";
import { TaxUnits } from "../../../utils/constant";
import { updateTaxationCharges } from "../../../utils/api/taxation";
import toast from "react-hot-toast";

const UserCharges = ({ name, unit, user_origin = null, value, no , type , title=""  }) => {
  const UserType = ({ name, type = null }) => {
    return (
      <div>
        {name}{" "}
        {type != null && (
          <span
            className={`text-[10px] font-bold ${
              type == "NAT" ? "text-green-500 " : "text-blue-500"
            } `}
          >
            {type}
          </span>
        )}
      </div>
    );
  };

  const [selectedTaxUnit, setSelectedTaxUnit] = useState(unit || null);

  const [inputValue, setInputValue] = useState(value || "");

  const handleSelectChange = (value) => {
    // console.log("Selected Tax Unit:", value);
    setSelectedTaxUnit(value);
  };

  const handleUpdateTaxationCharges = async () => {
    let requestBody = {
      user_origin: user_origin,
      [type]: {
        unit: selectedTaxUnit,
        value: inputValue,
      },
    };

    try {
      let result = await updateTaxationCharges(requestBody);

      if (result) {
        toast.success(`${title} Charges Updated Successfully`);
      }
    } catch (error) {
      toast.error(`Error Updating ${title} Charges`);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (/^\d*\.?\d{0,2}$/.test(value)){
      // console.log("Input Value:", value);
      setInputValue(value);
    }
  };
  const handleBlur = () => {
    if(value!==inputValue||unit !==selectedTaxUnit ){
      handleUpdateTaxationCharges();
    }
  };
  return (
    <div
      className={`${
        no % 2 != 0 ? "bg-white" : "bg-blue-100"
      } px-10 py-2 flex justify-between  `}
    >
      <div className="text-sm  w-1/6 flex  justify-between items-center ">
        <UserType name={name} type={user_origin} />
      </div>
      <div className="flex w-1/5 justify-between">
        <Select
          showSearch
          className="primary_variant"
          optionFilterProp="label"
          suffixIcon={<DownIcon className="w-[11px] h-[5px] text-[#808080]" />}
          placeholder={"Tax Units"}
          options={TaxUnits}
          value={selectedTaxUnit}
          onChange={handleSelectChange}
          onBlur={handleBlur}

        />
        <Input
          className="border-0 border-b-2 rounded-none ml-4"
          value={inputValue}
          onChange={handleInputChange}
          inputMode="text" // This helps bring up the numeric keypad on mobile devices
          onBlur={handleBlur}

        />
      </div>
    </div>
  );
};

export default UserCharges;
